import topBannerSchedule from './topBannerSchedule.json'

interface TopBannerSource {
  id: string
  src: string
  alt: string
  href: string
}

export interface TopBanner extends TopBannerSource {
  /** 週替わり掲載枠のバナーか（掲載期間外に戻る既定バナーは false） */
  isScheduled: boolean
}

interface ScheduledTopBanner extends TopBannerSource {
  /** 掲載開始日（JST・YYYY-MM-DD。当日を含む） */
  startDate: string
  /** 掲載終了日（JST・YYYY-MM-DD。当日を含む） */
  endDate: string
}

const DEFAULT_BANNER: TopBannerSource = topBannerSchedule.default
const SCHEDULE: ScheduledTopBanner[] = topBannerSchedule.schedule

const JST_OFFSET_MS = 9 * 60 * 60 * 1000

/**
 * 端末のタイムゾーンに関係なく JST の暦日（YYYY-MM-DD）へ落とす。
 * 掲載期間は日本時間の日付で運用するため、比較は必ずこのキーで行う。
 */
function toJstDateKey(date: Date): string {
  return new Date(date.getTime() + JST_OFFSET_MS).toISOString().slice(0, 10)
}

function toTopBanner(source: TopBannerSource, isScheduled: boolean): TopBanner {
  return {
    id: source.id,
    src: source.src,
    alt: source.alt,
    href: source.href,
    isScheduled
  }
}

/**
 * 週替わりトップバナーの掲載表。掲載期間外（開始前・終了後）は既定バナーへ戻す。
 */
export function resolveTopBanner(date: Date): TopBanner {
  const today = toJstDateKey(date)
  const scheduled = SCHEDULE.find(function (banner) {
    return banner.startDate <= today && today <= banner.endDate
  })
  return scheduled
    ? toTopBanner(scheduled, true)
    : toTopBanner(DEFAULT_BANNER, false)
}
